// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/creator/booking/v1/booking.proto (package fingertip.creator.booking.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BoolValue, Int32Value, proto3, StringValue, Timestamp } from "@bufbuild/protobuf";
import { BookingItem } from "../../../common/type/v1/booking_item_pb.js";
import { EventType } from "../../../common/type/v1/event_type_pb.js";
import { Booking } from "../../../common/type/v1/booking_pb.js";
import { SiteContact } from "../../../common/type/v1/site_contact_pb.js";
import { UserProfile } from "../../../common/type/v1/user_profile_pb.js";
import { PageInfo } from "../../../common/type/v1/page_info_pb.js";
import { ExternalCalendarEvent } from "../../../common/type/v1/external_calendar_event_pb.js";
import { StorePayment } from "../../../common/type/v1/store_payment_pb.js";
import { StoreInvoice } from "../../../common/type/v1/store_invoice_pb.js";
import { PaymentTotals } from "../../../common/type/v1/payment_totals_pb.js";
import { BookingResponse } from "../../../common/type/v1/booking_response_pb.js";
import { BookingStatus } from "../../../common/enum/v1/booking_status_pb.js";
import { Site } from "../../../common/type/v1/site_pb.js";
import { Page } from "../../../common/type/v1/page_pb.js";
import { StoreConfig } from "../../../common/type/v1/store_config_pb.js";

/**
 * @generated from message fingertip.creator.booking.v1.GetBookingConfigRequest
 */
export const GetBookingConfigRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetBookingConfigRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetBookingConfigResponse
 */
export const GetBookingConfigResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetBookingConfigResponse",
  () => [
    { no: 1, name: "event_types_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "schedules_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "active_connections_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "booking_onboarding_completed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "bookings_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "site_uses_conferencing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "connections_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "group_classes_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "booking_requests_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "assignments_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "user_assignments_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "user_schedules_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "user_active_connections_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "user_booking_onboarding_completed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetBookingConfigPublicRequest
 */
export const GetBookingConfigPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetBookingConfigPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetBookingConfigPublicResponse
 */
export const GetBookingConfigPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetBookingConfigPublicResponse",
  () => [
    { no: 1, name: "event_types_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "schedules_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "active_connections_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "booking_onboarding_completed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "bookings_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "site_uses_conferencing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "connections_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "group_classes_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "booking_requests_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "assignments_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetBookingsRequest
 */
export const GetBookingsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetBookingsRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "site_contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.BookingItemRecord
 */
export const BookingItemRecord = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.BookingItemRecord",
  () => [
    { no: 1, name: "booking_item", kind: "message", T: BookingItem },
    { no: 3, name: "event_type", kind: "message", T: EventType },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.BookingRecord
 */
export const BookingRecord = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.BookingRecord",
  () => [
    { no: 1, name: "booking", kind: "message", T: Booking },
    { no: 2, name: "contact", kind: "message", T: SiteContact },
    { no: 3, name: "items", kind: "message", T: BookingItemRecord, repeated: true },
    { no: 4, name: "user", kind: "message", T: UserProfile },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetBookingsResponse
 */
export const GetBookingsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetBookingsResponse",
  () => [
    { no: 1, name: "bookings", kind: "message", T: Booking, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.BookingRequestItem
 */
export const BookingRequestItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.BookingRequestItem",
  () => [
    { no: 1, name: "booking", kind: "message", T: Booking },
    { no: 2, name: "contact", kind: "message", T: SiteContact },
    { no: 3, name: "event_type", kind: "message", T: EventType },
    { no: 4, name: "items", kind: "message", T: BookingItemRecord, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetBookingRequestsRequest
 */
export const GetBookingRequestsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetBookingRequestsRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetBookingRequestsResponse
 */
export const GetBookingRequestsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetBookingRequestsResponse",
  () => [
    { no: 1, name: "booking_requests", kind: "message", T: BookingRequestItem, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetBookingsInRangeRequest
 */
export const GetBookingsInRangeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetBookingsInRangeRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "start", kind: "message", T: Timestamp },
    { no: 3, name: "end", kind: "message", T: Timestamp },
    { no: 4, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "event_status_filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetBookingsInRangeResponse
 */
export const GetBookingsInRangeResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetBookingsInRangeResponse",
  () => [
    { no: 2, name: "items", kind: "message", T: BookingRecord, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.CreateExternalCalendarEventRequest
 */
export const CreateExternalCalendarEventRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.CreateExternalCalendarEventRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "start_time", kind: "message", T: Timestamp },
    { no: 5, name: "end_time", kind: "message", T: Timestamp },
    { no: 6, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.CreateExternalCalendarEventResponse
 */
export const CreateExternalCalendarEventResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.CreateExternalCalendarEventResponse",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.DeleteExternalCalendarEventRequest
 */
export const DeleteExternalCalendarEventRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.DeleteExternalCalendarEventRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.DeleteExternalCalendarEventResponse
 */
export const DeleteExternalCalendarEventResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.DeleteExternalCalendarEventResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetExternalCalendarEventsInRangeRequest
 */
export const GetExternalCalendarEventsInRangeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetExternalCalendarEventsInRangeRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "start", kind: "message", T: Timestamp },
    { no: 3, name: "end", kind: "message", T: Timestamp },
    { no: 4, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.ExternalCalendarEventRecord
 */
export const ExternalCalendarEventRecord = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.ExternalCalendarEventRecord",
  () => [
    { no: 1, name: "event", kind: "message", T: ExternalCalendarEvent },
    { no: 2, name: "user", kind: "message", T: UserProfile },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetExternalCalendarEventsInRangeResponse
 */
export const GetExternalCalendarEventsInRangeResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetExternalCalendarEventsInRangeResponse",
  () => [
    { no: 2, name: "items", kind: "message", T: ExternalCalendarEventRecord, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.BookingPaymentItem
 */
export const BookingPaymentItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.BookingPaymentItem",
  () => [
    { no: 1, name: "payment", kind: "message", T: StorePayment },
    { no: 2, name: "refunds", kind: "message", T: StorePayment, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetBookingRequest
 */
export const GetBookingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetBookingRequest",
  () => [
    { no: 1, name: "booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetBookingResponse
 */
export const GetBookingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetBookingResponse",
  () => [
    { no: 1, name: "booking", kind: "message", T: Booking },
    { no: 2, name: "contacts", kind: "message", T: SiteContact, repeated: true },
    { no: 3, name: "payments", kind: "message", T: BookingPaymentItem, repeated: true },
    { no: 4, name: "event_type", kind: "message", T: EventType },
    { no: 5, name: "invoice", kind: "message", T: StoreInvoice },
    { no: 6, name: "items", kind: "message", T: BookingItemRecord, repeated: true },
    { no: 7, name: "user", kind: "message", T: UserProfile },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetBookingPublicRequest
 */
export const GetBookingPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetBookingPublicRequest",
  () => [
    { no: 1, name: "booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetBookingPublicResponse
 */
export const GetBookingPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetBookingPublicResponse",
  () => [
    { no: 1, name: "booking", kind: "message", T: Booking },
    { no: 2, name: "contacts", kind: "message", T: SiteContact, repeated: true },
    { no: 3, name: "event_type", kind: "message", T: EventType },
    { no: 4, name: "invoice", kind: "message", T: StoreInvoice },
    { no: 5, name: "items", kind: "message", T: BookingItemRecord, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetBookingPaymentDetailsPublicRequest
 */
export const GetBookingPaymentDetailsPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetBookingPaymentDetailsPublicRequest",
  () => [
    { no: 1, name: "booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.SavedPaymentMethod
 */
export const SavedPaymentMethod = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.SavedPaymentMethod",
  () => [
    { no: 1, name: "payment_method_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "last4", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "brand", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetBookingPaymentDetailsPublicResponse
 */
export const GetBookingPaymentDetailsPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetBookingPaymentDetailsPublicResponse",
  () => [
    { no: 1, name: "booking", kind: "message", T: Booking },
    { no: 2, name: "contacts", kind: "message", T: SiteContact, repeated: true },
    { no: 3, name: "event_type", kind: "message", T: EventType },
    { no: 4, name: "invoice", kind: "message", T: StoreInvoice },
    { no: 5, name: "primary_contact", kind: "message", T: SiteContact },
    { no: 6, name: "deposit_totals", kind: "message", T: PaymentTotals },
    { no: 7, name: "non_deposit_totals", kind: "message", T: PaymentTotals },
    { no: 8, name: "pending_deposit", kind: "message", T: BoolValue },
    { no: 9, name: "saved_payment_method", kind: "message", T: SavedPaymentMethod },
    { no: 10, name: "items", kind: "message", T: BookingItemRecord, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.AssignmentOption
 */
export const AssignmentOption = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.AssignmentOption",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "integration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.CreateBookingTime
 */
export const CreateBookingTime = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.CreateBookingTime",
  () => [
    { no: 1, name: "start_time", kind: "message", T: Timestamp },
    { no: 2, name: "end_time", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.CreateBookingRequest
 */
export const CreateBookingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.CreateBookingRequest",
  () => [
    { no: 1, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "start_time", kind: "message", T: Timestamp },
    { no: 3, name: "end_time", kind: "message", T: Timestamp },
    { no: 4, name: "response", kind: "message", T: BookingResponse },
    { no: 5, name: "metadata", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "time_zone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "assignment_options", kind: "message", T: AssignmentOption, repeated: true },
    { no: 10, name: "target_booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "form_response_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "price_in_cents", kind: "message", T: Int32Value },
    { no: 15, name: "event_types", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
    { no: 16, name: "times", kind: "message", T: CreateBookingTime, repeated: true },
    { no: 17, name: "is_requesting_date", kind: "message", T: BoolValue },
    { no: 18, name: "custom_price", kind: "message", T: Int32Value },
    { no: 19, name: "custom_length", kind: "message", T: Int32Value },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.CreateBookingResponse
 */
export const CreateBookingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.CreateBookingResponse",
  () => [
    { no: 1, name: "booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.CreateBookingPublicRequest
 */
export const CreateBookingPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.CreateBookingPublicRequest",
  () => [
    { no: 1, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "start_time", kind: "message", T: Timestamp },
    { no: 3, name: "end_time", kind: "message", T: Timestamp },
    { no: 4, name: "response", kind: "message", T: BookingResponse },
    { no: 5, name: "metadata", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "time_zone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "assignment_options", kind: "message", T: AssignmentOption, repeated: true },
    { no: 10, name: "target_booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "form_response_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "event_types", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
    { no: 15, name: "custom_price", kind: "message", T: Int32Value },
    { no: 16, name: "custom_length", kind: "message", T: Int32Value },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.CreateBookingPublicResponse
 */
export const CreateBookingPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.CreateBookingPublicResponse",
  () => [
    { no: 1, name: "booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.UpdateBookingRequest
 */
export const UpdateBookingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.UpdateBookingRequest",
  () => [
    { no: 1, name: "booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "start_time", kind: "message", T: Timestamp },
    { no: 4, name: "end_time", kind: "message", T: Timestamp },
    { no: 5, name: "status", kind: "enum", T: proto3.getEnumType(BookingStatus) },
    { no: 6, name: "cancellation_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "rejection_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "rescheduled_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "rescheduled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "assignment_options", kind: "message", T: AssignmentOption, repeated: true },
    { no: 11, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "disable_reschedule", kind: "message", T: BoolValue },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.UpdateBookingResponse
 */
export const UpdateBookingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.UpdateBookingResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.UpdateBookingPropertyRequest
 */
export const UpdateBookingPropertyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.UpdateBookingPropertyRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "disable_reschedule", kind: "message", T: BoolValue },
    { no: 4, name: "refundable", kind: "message", T: BoolValue },
    { no: 5, name: "title", kind: "message", T: StringValue },
    { no: 6, name: "description", kind: "message", T: StringValue },
    { no: 7, name: "booking_policy", kind: "message", T: StringValue },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.UpdateBookingPropertyResponse
 */
export const UpdateBookingPropertyResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.UpdateBookingPropertyResponse",
  () => [
    { no: 1, name: "booking", kind: "message", T: Booking },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.RescheduleBookingRequest
 */
export const RescheduleBookingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.RescheduleBookingRequest",
  () => [
    { no: 1, name: "booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "start_time", kind: "message", T: Timestamp },
    { no: 4, name: "end_time", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.RescheduleBookingResponse
 */
export const RescheduleBookingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.RescheduleBookingResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.DeleteBookingRequest
 */
export const DeleteBookingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.DeleteBookingRequest",
  () => [
    { no: 1, name: "booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.DeleteBookingResponse
 */
export const DeleteBookingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.DeleteBookingResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.AcceptBookingRequestRequest
 */
export const AcceptBookingRequestRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.AcceptBookingRequestRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.AcceptBookingRequestResponse
 */
export const AcceptBookingRequestResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.AcceptBookingRequestResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.DeclineBookingRequestRequest
 */
export const DeclineBookingRequestRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.DeclineBookingRequestRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "cancellation_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.DeclineBookingRequestResponse
 */
export const DeclineBookingRequestResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.DeclineBookingRequestResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.ConfirmBookingRequestPublicRequest
 */
export const ConfirmBookingRequestPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.ConfirmBookingRequestPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.ConfirmBookingRequestPublicResponse
 */
export const ConfirmBookingRequestPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.ConfirmBookingRequestPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.CompleteBookingRequest
 */
export const CompleteBookingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.CompleteBookingRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "no_show", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "charge_amount_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.CompleteBookingResponse
 */
export const CompleteBookingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.CompleteBookingResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.CancelBookingPublicRequest
 */
export const CancelBookingPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.CancelBookingPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "cancellation_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.CancelBookingPublicResponse
 */
export const CancelBookingPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.CancelBookingPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.RejectBookingRequest
 */
export const RejectBookingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.RejectBookingRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "booking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "cancellation_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "charge_cancellation_fee", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.RejectBookingResponse
 */
export const RejectBookingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.RejectBookingResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetBookingAssignmentOptionsRequest
 */
export const GetBookingAssignmentOptionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetBookingAssignmentOptionsRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetBookingAssignmentOptionsResponse
 */
export const GetBookingAssignmentOptionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetBookingAssignmentOptionsResponse",
  () => [
    { no: 1, name: "assignment_options", kind: "message", T: AssignmentOption, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetCustomerBookingsItem
 */
export const GetCustomerBookingsItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetCustomerBookingsItem",
  () => [
    { no: 1, name: "booking", kind: "message", T: Booking },
    { no: 2, name: "event_type", kind: "message", T: EventType },
    { no: 3, name: "site", kind: "message", T: Site },
    { no: 4, name: "page", kind: "message", T: Page },
    { no: 5, name: "config", kind: "message", T: StoreConfig },
    { no: 6, name: "items", kind: "message", T: BookingItemRecord, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetCustomerBookingsRequest
 */
export const GetCustomerBookingsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetCustomerBookingsRequest",
  () => [
    { no: 1, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "start", kind: "message", T: Timestamp },
    { no: 5, name: "end", kind: "message", T: Timestamp },
    { no: 6, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "event_status_filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetCustomerBookingsResponse
 */
export const GetCustomerBookingsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetCustomerBookingsResponse",
  () => [
    { no: 1, name: "items", kind: "message", T: GetCustomerBookingsItem, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetCustomBookingSelectionTokenRequest
 */
export const GetCustomBookingSelectionTokenRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetCustomBookingSelectionTokenRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "assignee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_types", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
    { no: 4, name: "custom_length", kind: "message", T: Int32Value },
    { no: 5, name: "custom_price", kind: "message", T: Int32Value },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.GetCustomBookingSelectionTokenResponse
 */
export const GetCustomBookingSelectionTokenResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.GetCustomBookingSelectionTokenResponse",
  () => [
    { no: 1, name: "selection", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.VerifyCustomBookingRequest
 */
export const VerifyCustomBookingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.VerifyCustomBookingRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "selection", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.booking.v1.VerifyCustomBookingResponse
 */
export const VerifyCustomBookingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.booking.v1.VerifyCustomBookingResponse",
  () => [
    { no: 1, name: "valid", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "assignee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_types", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
    { no: 4, name: "custom_length", kind: "message", T: Int32Value },
    { no: 5, name: "custom_price", kind: "message", T: Int32Value },
  ],
);

